/**
 * The library entry drawer's width, per signed-in uid so people sharing a
 * browser keep their own; the rules (min, max, snaps) are in `drawerWidth.ts`.
 */
import { create } from "zustand";
import { persist } from "zustand/middleware";

import { DRAWER_DEFAULT_WIDTH } from "./drawerWidth";

type State = {
  widthByUid: Record<string, number>;
  setWidth: (uid: string, width: number) => void;
};

export const ENTRY_DRAWER_STORAGE_KEY = "firmKnowledge.entryDrawer";

export const useEntryDrawerStore = create<State>()(
  persist(
    (set) => ({
      widthByUid: {},
      setWidth: (uid, width) =>
        set((s) => ({ widthByUid: { ...s.widthByUid, [uid]: width } }))
    }),
    {
      name: ENTRY_DRAWER_STORAGE_KEY,
      partialize: (s) => ({ widthByUid: s.widthByUid })
    }
  )
);

/** The storage key for a signed-in uid (one shared key before sign-in resolves). */
export const entryDrawerUidKey = (uid: string | null | undefined): string =>
  uid || "_";

/** The signed-in person's drawer width (the default until they resize). */
export const useEntryDrawerWidth = (uid: string | null | undefined): number =>
  useEntryDrawerStore(
    (s) => s.widthByUid[entryDrawerUidKey(uid)] ?? DRAWER_DEFAULT_WIDTH
  );
